import { Boolean, Record, Static } from "runtypes";

export const CookieSettings = Record({
  performance: Boolean,
  functionality: Boolean,
});

export type CookieSettings = Static<typeof CookieSettings>;
